// extracted by mini-css-extract-plugin
export default {"container":"burger-ingredients-list_container__tUtoE"};